import * as SC from "./LogoStyled"

const Logo:React.FC = () => {
    return <SC.LogoStyled>devfinder</SC.LogoStyled>;
}
 
export default Logo;